var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppointmentProviderPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 42.5c0 12.438-5.344 23.629-13.86 31.402C63.584 80.795 53.534 85 42.5 85c-11.034 0-21.084-4.205-28.64-11.098C5.344 66.129 0 54.938 0 42.5 0 19.029 19.029 0 42.5 0S85 19.029 85 42.5Z",
    fill: "#FFAA20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 42.5c0 12.438-5.344 23.629-13.86 31.402C63.584 80.795 53.534 85 42.5 85V0C65.971 0 85 19.029 85 42.5Z",
    fill: "#FF8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14 73.733v.169C63.586 80.796 53.536 85 42.502 85c-11.034 0-21.084-4.204-28.64-11.098v-.17c0-12.311 7.81-22.835 18.737-26.872a28.464 28.464 0 0 1 9.903-1.766c3.48 0 6.816.624 9.905 1.766C63.333 50.9 71.14 61.421 71.14 73.733Z",
    fill: "#7985EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14 73.733v.169C63.584 80.796 53.534 85 42.5 85V45.094c3.48 0 6.816.624 9.904 1.766C63.332 50.9 71.14 61.421 71.14 73.733Z",
    fill: "#4B5BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.065 32.36c0 9.685-7.878 17.566-17.566 17.566-9.685 0-17.565-7.88-17.565-17.566s7.88-17.566 17.565-17.566c9.688 0 17.566 7.88 17.566 17.566Z",
    fill: "#FFDBA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.066 32.36c0 9.685-7.879 17.566-17.566 17.566V14.794c9.687 0 17.566 7.88 17.566 17.566Z",
    fill: "#FFC473"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h85v85H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointmentProviderPlaceholder);
export default __webpack_public_path__ + "static/media/icon_appointment_provider_placeholder.41f9446a.svg";
export { ForwardRef as ReactComponent };